"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Created on 10 01 2020
 */

var StructPropBuilder_1 = require("../data-dictionary/StructPropBuilder");

var Range_1 = require("../Range");
/**
 * <p>Implementation of {@link Range} for 'number'.</p>
 *
 * @author JMe
 */


var NumberRange =
/*#__PURE__*/
function (_Range_1$Range) {
  _inherits(NumberRange, _Range_1$Range);

  function NumberRange() {
    _classCallCheck(this, NumberRange);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumberRange).apply(this, arguments));
  }

  _createClass(NumberRange, null, [{
    key: "of",
    value: function of(minimum, maximum) {
      return new NumberRange(minimum, maximum);
    }
  }]);

  return NumberRange;
}(Range_1.Range);

exports.NumberRange = NumberRange;
NumberRange.EMPTY = new NumberRange(null, null);

NumberRange.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(NumberRange.name);
  return {
    minimum: builder.opt(builder.num('minimum')),
    maximum: builder.opt(builder.num('maximum'))
  };
}();